import { useQuery } from 'react-query';
import axios from 'axios';

type Config = {
  termsAndConditions?: {
    url: string;
  };
  general: {
    // eslint-disable-next-line camelcase
    display_name: string;
  };
};

export const configKeys = {
  keys: ['keys'] as const,
};

export const useInstitutionConfig = () =>
  useQuery<Config, Error>(configKeys.keys, async () => {
    const {
      data: { termsAndConditions, general },
    } = await axios.post(`conf/read`, {
      modules: ['termsAndConditions', 'general'],
    });

    return {
      termsAndConditions,
      general,
    };
  });
